export default __webpack_public_path__ + "static/media/cook10.cfd10028.png";